import React, { useState } from 'react';
import JBrowseService from '../services/jbrowse.service';
import EventBus from '../common/EventBus';
import _ from 'underscore';
import dayjs from 'dayjs';

// MUI Imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  IconButton,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CreateNotesModal = (props) => {
    const {
        createNotesModalIsOpen,
        setCreateNotesModalIsOpen,
        location,
        setLocation,
        currentUser,
        selectedAssembly,
        setLoading,
        createTracks,
        selectedTracks,
        setCurrentTracks,
        setCurrentSession,
        createDefaultSession,
        updateTracks,
        setNotes
    } = props;

    const [isVisible, setIsVisible] = useState(true);
    const [category, setCategory] = useState('');
    const [noteClass, setNoteClass] = useState('');
    const [noteContent, setNoteContent] = useState('');
    const [isTemporary, setIsTemporary] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const saveNote = () => {
        setLoading(true);
        console.log("loc: ", location);
        const [chromosomePart, rangePart] = location.split(':');
        const [start, end] = rangePart.split('-');

        console.log(`Chromosome: ${chromosomePart}`);
        console.log(`Start: ${start}`);
        console.log(`End: ${end}`);

        const now = dayjs();
        const mysqlTimestamp = now.format('YYYY-MM-DD HH:mm:ss');

        let obj = {
            notes: {
                location: location,
                category: category,
                noteClass: noteClass,
                noteContent: noteContent,
                isTemporary: isTemporary,
                chromosome: chromosomePart,
                created_at: mysqlTimestamp,
                start: start,
                end: end,
            },
            user: currentUser,
            reference: selectedAssembly,
        };
        console.log("obj: ", obj);

        JBrowseService.createNote(obj).then(
            (response) => {
                console.log("create notes response: ", response);
                let notes_obj = {
                    idCompany: currentUser.idCompany,
                    username: currentUser.email,
                    assembly: selectedAssembly,
                };
                console.log("notes_obj: ", notes_obj);

                setTimeout(() => {
                    JBrowseService.getNotes(notes_obj).then(
                        (response) => {
                            console.log("notes response: ", response);
                            let notes = [];
                            _.each(response.result, function (value) {
                                var obj = value;
                                obj.created_at = dayjs(value.created_at).format('MMMM D YYYY, h:mm:ss A');
                                notes.push(obj);
                            });
                            console.log("notes: ", notes);
                            setNotes(notes);
                            setCategory("");
                            setNoteClass("");
                            setNoteContent("");
                            setSuccessMessage('Your note has been uploaded successfully!');
                            setLoading(false);
                            setTimeout(() => {
                                setSuccessMessage('');
                            }, 3000);
                        },
                        (error) => {
                            console.log("error: ", error);
                        }
                    );
                }, 2000);
            },
            (error) => {
                console.log("error: ", error);
                if (error.code === "ERR_NETWORK") {
                    console.warn("logout!!!");
                    EventBus.dispatch("logout");
                }
                setLoading(false);
            }
        );
    };

    const toggleModal = () => {
        setCreateNotesModalIsOpen(!createNotesModalIsOpen);
    };

    return (
      <Dialog
        open={createNotesModalIsOpen}
        onClose={toggleModal}
        fullWidth
        maxWidth="sm"
        // This ensures a stronger shadow backdrop behind the dialog
        BackdropProps={{
          style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
        }}
        PaperProps={{
          elevation: 24
        }}
      >
        <DialogTitle sx={{ borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Notes</Typography>
          <IconButton onClick={toggleModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {/* Location */}
          <Box mb={2}>
            <Typography component="label" variant="body2" fontWeight="bold" sx={{ display: 'block', mb: 1 }}>
              Location
            </Typography>
            <TextField
              type="text"
              id="location"
              placeholder="Location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              fullWidth
            />
          </Box>

          {/* Type */}
          <Box mt={2}>
            <Typography component="label" variant="body2" fontWeight="bold" sx={{ display: 'block', mb: 1 }}>
              Type
            </Typography>
            <FormControl fullWidth>
              <InputLabel id="type-label">Please select</InputLabel>
              <Select
                labelId="type-label"
                id="type"
                label="Please select"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <MenuItem value="" disabled>Please select</MenuItem>
                <MenuItem value="Gene">Gene</MenuItem>
                <MenuItem value="Variant">Variant</MenuItem>
                <MenuItem value="Primer">Primer</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Class */}
          <Box mt={2}>
            <Typography component="label" variant="body2" fontWeight="bold" sx={{ display: 'block', mb: 1 }}>
              Class
            </Typography>
            <FormControl fullWidth>
              <InputLabel id="class-label">Please select</InputLabel>
              <Select
                labelId="class-label"
                id="class"
                label="Please select"
                value={noteClass}
                onChange={(e) => setNoteClass(e.target.value)}
              >
                <MenuItem value="" disabled>Please select</MenuItem>
                <MenuItem value="Private">Private (User)</MenuItem>
                <MenuItem value="Public">Public (Company)</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Notes */}
          <Box mt={2}>
            <Typography component="label" variant="body2" fontWeight="bold" sx={{ display: 'block', mb: 1 }}>
              Notes
            </Typography>
            <TextField
              id="createNote"
              placeholder="Notes..."
              multiline
              rows={5}
              value={noteContent}
              onChange={(e) => setNoteContent(e.target.value)}
              fullWidth
            />
          </Box>

          {/* Success Message */}
          {successMessage && (
            <Box
              mt={2}
              sx={{
                backgroundColor: '#f0fdf4',
                border: '1px solid #a3e3a1',
                color: '#15803d',
                borderRadius: 1,
                position: 'relative',
                p: 2
              }}
            >
              <Typography variant="body2">{successMessage}</Typography>
              <Box
                sx={{ position: 'absolute', top: 4, right: 4, cursor: 'pointer' }}
                onClick={() => setSuccessMessage('')}
              >
                <svg
                  className="fill-current h-6 w-6 text-green-500"
                  role="button"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <title>Close</title>
                  <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                </svg>
              </Box>
            </Box>
          )}

          {/* Checkbox and Buttons */}
          <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
            <FormControlLabel
              control={
                <Checkbox
                  checked={isTemporary}
                  onChange={() => setIsTemporary(!isTemporary)}
                  color="primary"
                />
              }
              label="Temporary Note"
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={saveNote}
            startIcon={<i className="fas fa-save" />}
            sx={{ mr: 2 }}
          >
            Save Note
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            onClick={toggleModal}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
};

export default CreateNotesModal;
